import { CurrentUserData } from 'security';

export const canSearchAcrossProvider = (currentUser: CurrentUserData): boolean => ['THE_BHPN_ADMIN', 'THE_BHPN_ADMIN_WITH_PROVIDER_SUPPORT'].includes(currentUser.role);

export const hasEumAccess = (theUser: CurrentUserData | null): boolean => theUser?.canManageProviderUser ?? false;
